import { Dropdown, IComboBoxOption, ResponsiveMode } from "@fluentui/react";
import { DBApplication } from "../interfaces/CoObject";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setDefaultDB } from "../../redux/feature/general/session-settings-slice";
import { fetchGroupUserDB } from "../../api/object/Form";
import { useAppSelector } from "../../redux/hooks/hooks";
import { formatMessage } from "../../utils/helpers/LanguageHelper";

interface DbApplicationDropDownState {
  dbApplicationItems: IComboBoxOption[];
  selectedItem: IComboBoxOption;
}

interface DbApplicationDropDownProps {
  dbApplication: DBApplication;
  selectDbComboBox: (option: IComboBoxOption) => void;
  objectSource?: string;
  disabled?: boolean;
}

export const DbApplicationDropDown = (input: DbApplicationDropDownProps) => {
  const [state, setState] = React.useState<DbApplicationDropDownState>({
    dbApplicationItems: [],
    selectedItem: undefined,
  });

  const { dbApplicationItems, selectedItem } = state;

  const dispatch = useDispatch();

  const selectDB = (option: IComboBoxOption) => {
    setState((s) => ({ ...s, selectedItem: option }));
    dispatch(setDefaultDB(option.key.toString()));
    input.selectDbComboBox(option);
  };

  useEffect(() => {
    fetchGroupUserDB().then((dbs) => {
      const dbApplicationMap: IComboBoxOption[] = dbs.map((db) => {
        return {
          key: db.id,
          text: db.desc,
        };
      });
      setState({
        ...state,
        dbApplicationItems: dbApplicationMap,
      });
      if (input.dbApplication && !dbs.some((db) => db.id === input.dbApplication.id)) input.selectDbComboBox(null);
    });
  }, []);

  const defaultDB = useAppSelector((rootState) => rootState.sessionSettings.defaultDB);

  useEffect(() => {
    if (!input.dbApplication && !selectedItem) {
      if (state.dbApplicationItems.length === 1) selectDB(state.dbApplicationItems[0]);
      else if (defaultDB) {
        const defaultDBOption = state.dbApplicationItems.find((item) => item.key === defaultDB);
        if (defaultDBOption) {
          selectDB(defaultDBOption);
        }
      }
    }
  }, [state.dbApplicationItems, defaultDB]);

  useEffect(() => {
    setState({
      ...state,
      selectedItem: undefined,
    });
    dispatch(setDefaultDB(undefined));
  }, [input.objectSource]);

  return (
    <Dropdown
      id="application_dropdown"
      disabled={input.disabled}
      placeholder={formatMessage("cof.base.select")}
      label={formatMessage("cof.createnewobject.application")}
      options={dbApplicationItems}
      onChange={(_event, option) => selectDB(option)}
      selectedKey={input.dbApplication != null ? input.dbApplication.id : null}
      responsiveMode={ResponsiveMode.large}
      required
    />
  );
};
